import React from "react";
import LegalLayout from "./LegalLayout";

const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc list-outside pl-6 space-y-2 marker:text-[#B08D57]">
    {children}
  </ul>
);

export default function Accessibility() {
  return (
    <LegalLayout
      eyebrow="Accessibility"
      title="Accessibility Statement (AODA)"
      updated="February 2026"
      sections={[
        {
          id: "commitment",
          title: "1. Our commitment",
          body: (
            <P>
              Prospera Financial Inc. is committed to providing an inclusive,
              accessible experience for all clients and website visitors, in
              accordance with the{" "}
              <em>Accessibility for Ontarians with Disabilities Act, 2005
              </em>{" "}
              (AODA) and its regulations.
            </P>
          ),
        },
        {
          id: "standards",
          title: "2. Standards we follow",
          body: (
            <>
              <P>
                We design and maintain our website to meet the{" "}
                <strong>WCAG 2.1 Level AA</strong> guidelines. This includes:
              </P>
              <UL>
                <li>Sufficient colour contrast, resizable text, and clear focus states.</li>
                <li>Alternative text for meaningful images.</li>
                <li>Keyboard-only navigation for interactive elements.</li>
                <li>Semantic HTML and proper landmark roles for assistive technologies.</li>
                <li>Forms with visible labels and clear error messages.</li>
              </UL>
            </>
          ),
        },
        {
          id: "in-person",
          title: "3. Serving clients with disabilities in person",
          body: (
            <>
              <P>Our team is trained to:</P>
              <UL>
                <li>Communicate in ways that consider a client's disability.</li>
                <li>Welcome service animals and support persons.</li>
                <li>
                  Provide documents (illustrations, policies, plans) in
                  alternative formats on request: large print, plain-text
                  digital, or read-aloud during meetings.
                </li>
              </UL>
            </>
          ),
        },
        {
          id: "feedback",
          title: "4. Providing feedback",
          body: (
            <>
              <P>
                If you experience any barrier accessing our services or
                website, please let us know. We take feedback seriously and
                respond within two business days.
              </P>
              <UL>
                <li>
                  Email:{" "}
                  <a
                    href="mailto:info@prosperafinancial.ca"
                    className="text-[#8A6A2E] underline underline-offset-2"
                  >
                    info@prosperafinancial.ca
                  </a>
                </li>
                <li>Phone: +1 (416) 555-0102</li>
                <li>Written: Prospera Financial Inc., Toronto, Ontario</li>
              </UL>
              <P>
                Feedback may be provided anonymously. If you would like a
                response, please provide contact details.
              </P>
            </>
          ),
        },
        {
          id: "updates",
          title: "5. Updates to this statement",
          body: (
            <P>
              This statement is reviewed annually and updated whenever our
              accessibility practices materially change.
            </P>
          ),
        },
      ]}
    />
  );
}
